<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Quotations",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Quotations",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Quotations",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 10,
      IsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      delete: {
        id: "",
        customer: "",
      },
      dispatch: {
        id: "",
      },
      filterQuotations: {
        customer_id: "",
        product_id: "",
        status: "",
        quotation_number: "",
        receipt_number: "",
        datefrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 10,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("quotations", [
      "Quotations",
      "SaveStatus",
      "QuotationsPagination",
      "filterStatus",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("sales", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IsServerPaginated
        ? this.QuotationsPagination.total
        : this.Quotations
        ? this.Quotations.length
        : 0;
    },

    currentPage: {
      get() {
        return this.IsServerPaginated
          ? this.QuotationsPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsServerPaginated
          ? this.QuotationsPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsServerPaginated) {
          this.serverPerPage = value;
          this.filterQuotations.per_page = value;
          this.filterQuotations.page = 1;
          this.FilterQuotations();
        } else {
          this.clientPerPage = value;
        }
      },
    },

    statusOptions() {
      return [
        { id: "", name: "All Status" },
        { id: 0, name: "Pending" },
        { id: 1, name: "Partially Dispatched" },
        { id: 2, name: "Dispatched" },
      ];
    },

    /**
     * Todo list of records
     */
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchQuotations: "quotations/fetchQuotations",
      Delete: "quotations/deleteQuotation",
      DispatchQuotation: "quotations/dispatchQuotation",
      FetchCustomers: "customers/fetchCustomers",
      FetchItems: "sales/fetchItems",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    redirect(value) {
      this.$router.push(`/quotation/details/${btoa(value)}`);
    },

    SetdeleteData(data) {
      (this.delete.id = data.id), (this.delete.customer = data.customer);
    },

    DeleteQuotation(modalId) {
      this.Delete(this.delete);
      this.closeModal(modalId);
    },

    resetDelete() {
      (this.delete.id = ""), (this.delete.customer = "");
    },

    closeModal(modalId) {
      this.resetDelete();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    ViewDispatchModal(data) {
      this.dispatch.id = data.id;
    },

    DispatchItems(modalId) {
      this.DispatchQuotation(this.dispatch);
      this.closeModal(modalId);
    },

    handlePageChange(newPage) {
      if (this.IsServerPaginated) {
        let payload = {
          ...this.filterQuotations,
          page: newPage,
          per_page: this.serverPerPage,
        };
        this.filterQuotations.page = newPage;
        this.FetchQuotations(payload);
      }
    },

    FilterQuotations() {
      this.filterQuotations.page = 1;
      this.filterQuotations.per_page = this.serverPerPage;
      this.FetchQuotations(this.filterQuotations);
    },

    ClearFilters() {
      this.filterQuotations = {
        customer_id: "",
        product_id: "",
        status: "",
        quotation_number: "",
        receipt_number: "",
        datefrom: "",
        dateto: "",
        page: 1,
        per_page: this.serverPerPage,
      };
      this.FilterQuotations();
    },
  },
  created() {
    this.FetchCustomers();
    this.FetchItems();
    this.FilterQuotations();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Generated Quotations</h4>
              </div>
              <div
                class="col-md-3"
                align="right"
                v-if="BranchData.BranchId != 0"
              >
                <router-link to="/quotations/new"
                  ><b-button variant="primary"
                    ><i class="fa fa-plus"></i> Generate New</b-button
                  ></router-link
                >
              </div>
            </div>

            <!-- Filters Section -->
            <div class="row mt-4 mb-4">
              <div class="col-sm-3 col-md-3 form-group">
                <label>QUOTATION NUMBER</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterQuotations.quotation_number"
                  placeholder="Enter quotation number"
                  @keyup.enter="FilterQuotations()"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY CUSTOMER</label>
                <model-list-select
                  :list="
                    Customers
                      ? [{ id: '', name: 'All Customers' }, ...Customers]
                      : []
                  "
                  v-model="filterQuotations.customer_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="FilterQuotations()"
                >
                </model-list-select>
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY PRODUCT</label>
                <model-list-select
                  :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                  v-model="filterQuotations.product_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="FilterQuotations()"
                >
                </model-list-select>
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>FILTER BY STATUS</label>
                <model-list-select
                  :list="statusOptions"
                  v-model="filterQuotations.status"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Status"
                  @input="FilterQuotations()"
                />
              </div>
            </div>

            <!-- Search by Quotation/Receipt Number Row -->
            <div class="row mb-4">
              <div class="col-sm-3 col-md-3 form-group">
                <label>RECEIPT NUMBER</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterQuotations.receipt_number"
                  placeholder="Enter receipt number"
                  @keyup.enter="FilterQuotations()"
                />
              </div>
              <div class="col-sm-3 col-md-3 form-group">
                <label>FROM DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterQuotations.datefrom"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group">
                <label>TO DATE</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filterQuotations.dateto"
                />
              </div>

              <div class="col-sm-3 col-md-3 form-group d-flex align-items-end">
                <button class="btn btn-primary me-2" @click="FilterQuotations">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
                <b-button variant="secondary" @click="ClearFilters()">
                  <i class="fa fa-refresh"></i> Clear
                </b-button>
              </div>
            </div>

            <!-- Date Range Filter Row -->

            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-4"></div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0 mt-3">
              <table
                class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>DATE</th>
                    <th>VALID UNTIL</th>
                    <th>CUSTOMER</th>
                    <th>PRODUCTS</th>
                    <th>TOTAL</th>
                    <th>QUOTATION NUMBER</th>
                    <th>RECEIPT NUMBER</th>
                    <th>RECORDED ON</th>
                    <th>USER</th>
                    <th>STATUS</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>

                <tbody
                  v-if="!filterStatus && Quotations && Quotations.length > 0"
                >
                  <tr v-for="(item, index) in Quotations" :key="item.id">
                    <td>{{ QuotationsPagination.from + index }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.valid_until || "N/A" }}</td>
                    <td>{{ item.customer }}</td>
                    <td>
                      {{ item.all.length }}
                      {{ item.all.length === 1 ? "product" : "products" }}
                    </td>
                    <td>{{ thousandSeperator(item.total) }}</td>
                    <td>{{ item.quotation_number }}</td>
                    <td>{{ item.receipt || "N/A" }}</td>
                    <td>{{ item.dateAdded }}</td>
                    <td>{{ item.user }}</td>
                    <td>
                      <em v-if="item.status == 0" class="text-warning"
                        >Pending</em
                      >

                      <em v-else-if="item.status == 1" class="text-info"
                        >Partially Dispatched</em
                      >

                      <em v-else-if="item.status == 2" class="text-success"
                        >Dispatched</em
                      >
                    </td>
                    <td>
                      <b-button-group>
                        <b-button
                          v-if="item.status != 2"
                          size="sm"
                          variant="info"
                          v-b-modal.dispatch-item-modal
                          @click="ViewDispatchModal(item)"
                        >
                          <i class="fa fa-check"></i> Dispatch
                        </b-button>
                        <b-button
                          v-if="MyUserPerm.view_quotations == 1"
                          size="sm"
                          variant="primary"
                          @click="redirect(item.id)"
                        >
                          <i class="fa fa-eye"></i> View
                        </b-button>
                        <b-button
                          v-if="
                            item.status == 0 &&
                            MyUserPerm.delete_quotations == 1
                          "
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-modal
                          @click="SetdeleteData(item)"
                        >
                          <i class="fa fa-trash"></i> Delete
                        </b-button>
                      </b-button-group>
                    </td>
                  </tr>
                </tbody>

                <!-- Loading -->
                <tbody v-if="filterStatus">
                  <tr>
                    <td :colspan="12" class="text-center">
                      <div class="row">
                          <div class="skeleton-row" v-for="i in 5" :key="i"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <!-- No data -->
                <tbody
                  v-if="
                    !filterStatus && (!Quotations || Quotations.length === 0)
                  "
                >
                  <tr>
                    <td :colspan="12" class="text-center">
                      No quotations found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Receive modal starts -->
            <b-modal id="dispatch-item-modal" hide-footer>
              <template #modal-title>
                <h4 class="text-warning">
                  Dispatch Items on the quotation
                </h4></template
              >
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('dispatch-item-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="DispatchItems('dispatch-item-modal')"
                >
                  <i class="fa fa-arrow-down"></i> Dispatch
                </button>
              </div>
            </b-modal>
            <!-- Receive modal ends -->

            <!-- Delete Model -->
            <b-modal id="delete-modal" hide-footer @hidden="resetDelete()">
              <template #modal-title>
                <h4 class="text-danger">
                  Your are deleting this Quotation
                </h4></template
              >

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="DeleteQuotation('delete-modal')"
                >
                  <i class="fa fa-trash"></i> Delete
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
th {
  vertical-align: top;
  white-space: normal;
}
</style>
